export const STORE_NAME = 'publishpress-future/manual-post-trigger';
